import React from 'react';
import LoadingBar from '../components/system/LoadingBar';
import {
    Root,
    SecondaryContent,
    ContentWrapper,
} from './secondaryLayoutStyles';

const SecondaryWrapper: React.FCC = ({ children }) => {
    return (
        <Root>
            <SecondaryContent>
                <React.Suspense fallback={<LoadingBar show />}>
                    <ContentWrapper>{children}</ContentWrapper>
                </React.Suspense>
            </SecondaryContent>
        </Root>
    );
};

export default React.memo(SecondaryWrapper);
